import {CALL_API} from 'redux-api-middleware';
import {
  API_CLOSEOUT_GET_REQUEST,
  API_CLOSEOUT_GET_SUCCESS,
  API_CLOSEOUT_GET_FAILURE,
} from 'common/types';
import {ENDPOINT_CLOSEOUT} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

export default {
  getCloseout: (token, id) => {
    return {
      [CALL_API]: {
        endpoint: ENDPOINT_CLOSEOUT + id,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_CLOSEOUT_GET_REQUEST,
          API_CLOSEOUT_GET_SUCCESS,
          API_CLOSEOUT_GET_FAILURE,
        ],
      },
    };
  },
};
